import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ErrorPermission',
  setup(__props) {

//403页面

return { __sfc: true, }
}

})